import { useState, useEffect, FunctionComponent, } from 'react';
import { Button, Switch, Dialog } from '../../tailwindcomponents';
import { Typography, Input } from '../../tailwindcomponents';
import { Dictionary } from '../../components';
import { useSelector } from 'react-redux'
import { RootState } from '../../reducer';
import WarrantyApi from '../../api/warranty';
import { dictionary } from '../../types/general';

type CageCodeProps = {
  refreshCageCodes: Function,
}

// Basic dictionary page using the dictionary component so easy to change style of all dictionary pages if needed.
const EditCageCodes: FunctionComponent<CageCodeProps> = ({ refreshCageCodes }) => {
  const [cageCodes, setCageCodes] = useState(Array<dictionary>());
  const [newCageCodeName, setNewCageCodeName] = useState('');
  const [newCageCodeDescription, setNewCageCodeDescription] = useState('');
  const [newCageCodeEmail, setNewCageCodeEmail] = useState('');
  const store = useSelector((state: RootState) => state);
  const currentUser = store.user.me;
  const [showActive, setShowActive] = useState(true);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteReason, setDeleteReason] = useState('');
  const [selectedCageCode, setSelectedCageCode] = useState<dictionary | undefined>(undefined);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refresh = () => {
    WarrantyApi.getAllCageCodes().then(res => {
      setCageCodes(res.data);
      refreshCageCodes();
    });
  }
  const onReasonEdit = (value: string) => {
    setDeleteReason(value);
  }
  const addCageCode = (newCageCodeName: string, newCageCodeDescription: string) => {
    WarrantyApi.addNewCageCode(newCageCodeName, newCageCodeDescription, currentUser.user_id, newCageCodeEmail).then(res => {
      refresh();
      setNewCageCodeName('');
      setNewCageCodeDescription('');
      setNewCageCodeEmail('');
    });
  }
  const deleteCageCode = (cageCode: dictionary) => {
    setSelectedCageCode(cageCode);
    setDeleteDialogOpen(true);
  }
  const confirmDelete = () => {
    if (selectedCageCode !== undefined) {
      selectedCageCode.deleted_reason = deleteReason;
      WarrantyApi.deleteCageCode(selectedCageCode).then(res => {
        setSelectedCageCode(undefined);
        refresh();
      });
    }
    setDeleteDialogOpen(false);
    setDeleteReason('');
  }
  return (
    <div>
      <div className="flex flex-wrap w-full items-start justify-center">
        <div className="w-1/2">
          <div className="flex flex-wrap w-full">
            <div className="w-1/3 lg:w-2/3"></div>
            <div className="w-1/6 lg:w-1/12">
              <Typography text="Active" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
            </div>
            <div className="w-1/6 lg:w-1/12">
              <Switch
                checked={!showActive}
                onChange={() => setShowActive(!showActive)}
                color="secondary"
                name="checkedB"
              />
            </div>
            <div className="w-1/6 lg:w-1/12">
              <Typography text="Deleted" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
            </div>
          </div>
          <div className="w-5/6">
            {
              cageCodes !== undefined && cageCodes.filter(type => type.visible === showActive).map(row => (
                <Dictionary name={row.name} object={row} deleted={showActive === true ? false : true} description={showActive === true ? row.description : row.deleted_reason} other={row.other} id={row.id} deleteProperty={(row: dictionary) => deleteCageCode(row)}></Dictionary>
              ))
            }
          </div>
        </div>
        <Dialog
          visible={deleteDialogOpen}
          max_width={"md"} title={"Are you sure you want to delete this?"}
          context={
            <div>
              <div className="flex justify-center w-full m-2 p-2">
                <Input
                  label_text={"Type a reason"} value={deleteReason} help_text=""
                  onTextChange={(value: string) => onReasonEdit(value)} type="text" width={50} multiline={false} />
              </div>

              <div className="flex justify-center m-2 p-2">
                <div className="p-2">
                  <Button variant="contained" color="primary" onClick={() => confirmDelete()}>Confirm delete</Button>
                </div>
                <div className="p-2">
                  <Button variant="contained" color="secondary" onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
                </div>
              </div>
            </div>
          }
          onClose={(status: any) => setDeleteDialogOpen(false)}
          strict={false}
          show_options={false}
        />
        <div className="flex flex-wrap w-5/12">
          <div className="w-full">
            <br />
            <Input
              multiline={false}
              label_text="Name of new Cage code"
              help_text="Please type in a name for your new Cage code"
              type="text"
              value={newCageCodeName}
              width={50}
              onTextChange={(value: string) => setNewCageCodeName(value)}
            />
          </div>
          <div className="w-full">
            <Input
              multiline={false}
              label_text="Description for new Cage code"
              help_text="Please type in a description for your new Cage Code"
              type="text"
              value={newCageCodeDescription}
              width={50}
              onTextChange={(value: string) => setNewCageCodeDescription(value)}
            />
          </div>
          <div className="w-full">
            <Input
              multiline={false}
              label_text="Email address for new Cage code"
              help_text="Please type in an email address for your new Cage Code"
              type="text"
              value={newCageCodeEmail}
              width={50}
              onTextChange={(value: string) => setNewCageCodeEmail(value)}
            />
          </div>
          <br />
          <Button variant="contained" color="primary" className="bg-accent text-white text-sm" onClick={() => addCageCode(newCageCodeName, newCageCodeDescription)} >
            Add Property
          </Button>
        </div>
      </div>
    </div>
  );
};
export default EditCageCodes;
